<template>
    <div class="contentPanel">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'BenefitsPanel'
}
</script>

<style lang="scss" scoped>
.contentPanel {
    background-color: $colour__primary1;
    color: $white;
    padding: 3rem;
    min-width: 30rem;
    display: block;
    text-align: left;
}
</style>


